export default __webpack_public_path__ + "static/media/ravenrevampedlogo.dfed5bda.png";